module.exports = __webpack_public_path__ + "5d412cda50ca676e6c5f8af0c016c7e8.svg";